import styled from 'styled-components';
import type { PositionProps } from 'styled-system';
import { position } from 'styled-system';

import OffsetBox from './OffsetBox';
/**
 * Components to render positioned elements.
 */

const Position = styled(OffsetBox)<PositionProps>`
  ${position}
`;

export default Object.assign(Position, {
  absolute: styled(OffsetBox)<PositionProps>`
    ${position}
    position: absolute;
  `,
  fixed: styled(OffsetBox)<PositionProps>`
    ${position}
    position: fixed;
  `,
  relative: styled(OffsetBox)<PositionProps>`
    ${position}
    position: relative;
  `,
  sticky: styled(OffsetBox)<PositionProps>`
    ${position}
    position: sticky;
  `,
});
